import { ReactElement } from 'react';
import { t } from 'i18next';

import { Container } from './styles';

interface ChartCardEmptyStateProps {
  height?: string;
}

export function ChartCardEmptyState({
  height = '300px',
}: Readonly<ChartCardEmptyStateProps>): ReactElement {
  return <Container $height={height}>{t('nenhumDadoEncontrado')}</Container>;
}
